/**
 * Keeps excl./incl. BTW prices in sync on variant change.
 * Layout: €X ex. btw (primary) / €Y incl (secondary)
 * data-tax-price-mode:
 *   - inclusive: variant.price includes tax
 *   - exclusive: variant.price excludes tax
 */
(function () {
  if (window.__productPriceTaxInit) return;
  window.__productPriceTaxInit = true;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '€{{amount_with_comma_separator}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || '.';
      decimal = decimal || ',';

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return String(cents);

    let value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, '.', ',');
    }

    return formatString.replace(placeholderRegex, value);
  }

  function moneyFormat() {
    return (
      (window.theme && window.theme.moneyWithoutCurrencyFormat) ||
      (window.theme && window.theme.moneyFormat) ||
      '€{{amount_with_comma_separator}}'
    );
  }

  function splitPrices(price, rate, mode) {
    const safePrice = Number(price) || 0;
    const safeRate = Number(rate) || 21;

    if (safePrice === 0) {
      return { excl: 0, incl: 0 };
    }

    if (mode === 'inclusive') {
      return {
        excl: Math.round((safePrice * 100) / (100 + safeRate)),
        incl: safePrice,
      };
    }

    return {
      excl: safePrice,
      incl: Math.round((safePrice * (100 + safeRate)) / 100),
    };
  }

  function updateTaxPrices(variant) {
    if (!variant) return;

    const wrappers = document.querySelectorAll('[data-price-wrapper][data-vat-rate]');
    const format = moneyFormat();

    wrappers.forEach((wrap) => {
      const withoutTaxEl = wrap.querySelector('[data-product-price-without-tax]');
      const withTaxEl = wrap.querySelector('[data-product-price-with-tax]');
      const exclLabel = wrap.querySelector('.product__price-tax__label');
      if (!withoutTaxEl && !withTaxEl) return;

      const rate = parseFloat(wrap.getAttribute('data-vat-rate')) || 21;
      const mode = wrap.getAttribute('data-tax-price-mode') || 'inclusive';
      const price = Number(variant.price) || 0;
      const freeLabel = (window.theme && window.theme.strings && window.theme.strings.free) || 'Free';

      if (price === 0) {
        if (withoutTaxEl) withoutTaxEl.textContent = freeLabel;
        if (withTaxEl) withTaxEl.textContent = '';
        if (exclLabel) exclLabel.style.display = 'none';
        return;
      }

      const split = splitPrices(price, rate, mode);
      if (exclLabel) exclLabel.style.display = '';
      if (withoutTaxEl) withoutTaxEl.textContent = formatMoney(split.excl, format);
      if (withTaxEl) withTaxEl.textContent = formatMoney(split.incl, format);
    });
  }

  document.addEventListener('theme:variant:change', (event) => {
    updateTaxPrices(event.detail && event.detail.variant);
  });
})();
